module.exports = __webpack_public_path__ + "img/公告2.f133698d.jpg";